export default __webpack_public_path__ + "static/media/grafema_angura_04.11dd4029.jpg";